import { render, staticRenderFns } from "./AppContactDetail.vue?vue&type=template&id=2ccb9390"
import script from "./AppContactDetail.vue?vue&type=script&lang=js"
export * from "./AppContactDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports